import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { interval, Subscription, take } from 'rxjs';



@Component({
    selector: 'app-confirmation-snackbar',
    templateUrl: './confirmation-snackbar.component.html',
    styleUrl: './confirmation-snackbar.component.scss',
    standalone: false
})
export class ConfirmationSnackbarComponent implements OnInit {

  progressValue: number = 100;
  private subscription: Subscription | null = null;
  private durationWarning: number = 9000;
  
  constructor(
    private snackBarRef: MatSnackBarRef<ConfirmationSnackbarComponent>,
    
    @Inject(MAT_SNACK_BAR_DATA) public data: any) {
    }
    ngOnInit(): void {
      this.startCountdown();
    }
    startCountdown(): void {
      // Actualizar la barra  100ms
      const totalSteps = this.durationWarning / 100;
      const decrementPerStep = 100 / totalSteps;
      
      this.subscription = interval(100)
        .pipe(take(totalSteps))
        .subscribe({
          next: (step) => {
            this.progressValue = 100 - (step + 1) * decrementPerStep;
          },
          complete: () => {
           
          }
        });
    }

    closeSnackBar(): void {
      this.snackBarRef.dismiss();
    }

}
